import script from "./EditableItemGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditableItemGroup.vue?vue&type=script&setup=true&lang=ts"

import "./EditableItemGroup.vue?vue&type=style&index=0&id=6a1bff9a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1bff9a"]])

export default __exports__